import { Button } from "@mui/material";
import LoginIcon from "@mui/icons-material/Login";
import { useMsal } from "@azure/msal-react";
import styles from "./DuplicateEmailNotice.module.scss";
import { useTranslation } from "../../i18n";

export const DuplicateEmailNotice = () => {
  const { t } = useTranslation();
  const { instance } = useMsal();

  const handleSignIn = async () => {
    try {
      await instance.logoutRedirect({ postLogoutRedirectUri: "/login" });
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return (
    <div className={styles.notice}>
      <h2>{t("duplicateEmail.title")}</h2>
      <p>
        {t("duplicateEmail.text")}
      </p>
      <Button
        variant="contained"
        size="medium"
        startIcon={<LoginIcon />}
        onClick={handleSignIn}
      >
        {t("nav.login")}
      </Button>
    </div>
  );
};
